<div class="card-bet-now-button" title="{{ sitecore.marquee?.EmptyMarketLinkText }}" (click)="click()">
    <span>{{ sitecore.marquee?.EmptyMarketLinkText }}</span>
</div>
